import { Card, Grid, Icon, InputLabel, Menu, MenuItem } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import React, { memo, useCallback, useMemo, useState } from "react";
import PropTypes from "prop-types";
import SimpleTable from "components/Tables/SimpleTable";
import dataResiduosTransportados from "./dataResiduosTransportados";
import SoftBox from "components/SoftBox";
import { getColor } from "utils/colors";
import SinDatos from "components/Carteles/SinDatos";
import Firma from "../Firma";

const ResiduosTransportados = ({ listadoResiduosTransportados }) => {
  const { columns, getRows } = dataResiduosTransportados;

  const memoizedRows = useMemo(() => {
    if (listadoResiduosTransportados) {
      const listadoSinBorrar = listadoResiduosTransportados.filter((item) => !item.aBorrar);
      return getRows(listadoSinBorrar);
    }
    return [];
  }, [listadoResiduosTransportados]);

  return (
    <Grid container p={2}>
      <Grid item xs={12}>
        <SoftTypography color="black" variant="h4" fontWeight="bold">
          Residuos Transportados
        </SoftTypography>
      </Grid>
      <Grid item xs={12} py={1}>
        {listadoResiduosTransportados?.filter((item) => !item.aBorrar).length > 0 ? (
          <SimpleTable columns={columns} rows={memoizedRows} />
        ) : (
          <SinDatos textoTitulo="No hay residuos cargados" />
        )}
      </Grid>
      <Firma marginTop={10} />
    </Grid>
  );
};

export default memo(ResiduosTransportados);

ResiduosTransportados.propTypes = {
  listadoResiduosTransportados: PropTypes.array.isRequired,
};
